import { Link } from 'react-router-dom';

import { Gate } from '../../../global/contexts/auth/auth';
import { IconEdit } from '../../../common/icons';
import { useRace } from '../contexts/races';

import '../../../common/styles/catalog.css';

const STATUS_LABEL = { 2: 'Activo', 1: 'Inactivo', 0: 'Eliminado' };

function Field({ label, value }) {
    return (
        <div className="cat-detail__field">
            <span className="cat-detail__field-label">{label}</span>
            <span className="cat-detail__field-value">
                {value || <span className="cat-detail__empty">—</span>}
            </span>
        </div>
    );
}

export default function RaceDetail({ raceId }) {
    const { data: race, isLoading, error } = useRace(raceId);

    if (isLoading) return <div className="cat-detail__state">Cargando raza…</div>;
    if (error || !race) return <div className="cat-detail__state">Raza no encontrada.</div>;

    return (
        <div className="cat-detail">
            <header className="cat-detail__header">
                <div>
                    <Link to="/admin/races" className="cat-detail__back">Razas</Link>
                    <div className="cat-detail__title-row">
                        <h1 className="cat-detail__title">{race.name}</h1>
                        <span className={`cat-badge cat-badge--${race.status}`}>{STATUS_LABEL[race.status] || '—'}</span>
                    </div>
                </div>
                <Gate domain="races" action="write">
                    <Link to={`/admin/races/${race.id}/edit`} className="cat-detail__edit">
                        <IconEdit /><span>Editar</span>
                    </Link>
                </Gate>
            </header>

            <section className="cat-detail__card">
                <h2 className="cat-detail__section-title">Información</h2>
                <div className="cat-detail__grid">
                    <Field label="Código" value={race.code} />
                    <Field label="Estado" value={STATUS_LABEL[race.status]} />
                </div>
            </section>
        </div>
    );
}
